/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{text-align:center;color:#b0b0b0;font-weight:lighter;font-size:12px;margin:20px 0}\n/*# sourceMappingURL=app-version.component.css.map*/"];
export { styles as styles };
